
function GetMonthAbbr(date: Date): string {
    return [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ][date.getMonth()];
}

/*
export function FormatDate(date): string {

    if (date !== undefined && date !== "") {
        var myDate = new Date(date);
        var month = GetMonthAbbr(myDate);
        var str = myDate.getDate() + " " + month + " " + myDate.getFullYear();
        return str;
    }
    return "";
}

export function FormatDateMonthAbbrDayYear(date): string {
    if (date !== undefined && date !== "") {
        var myDate = new Date(date);
        var month = GetMonthAbbr(myDate);
        return `${month} ${myDate.getDate()} ${myDate.getFullYear()}`;
    }
    return "";
}
*/

export function getMonthYearDisplay(month: number, year: number): string {
    return new Date(year, month - 1, 1).toLocaleDateString("en-US", { month: "long", year: "numeric" });
}

export function FormatDate(date: Date, format: string = "day-mo-year"): string {
    if (date == undefined) return "";
    let month: string = GetMonthAbbr(date);

    if (format == "mo-day-year") { //Jan 15 2024
        return month + " " + String(date.getDate()).padStart(2, '0') + " " + date.getFullYear();
    }
    else if (format == "day-mo-year") { //15 Jan 2024
        return String(date.getDate()).padStart(2, '0') + " " + month + " " + date.getFullYear();
    }
}

export function GetDateFromString(dateString: string, format: string): Date {

    if (dateString == undefined || dateString.length == 0) return undefined;

    if (format == "hyphens-year-month-day") {
        let parts: string[] = dateString.split("-");
        return new Date(Number.parseInt(parts[0]), Number.parseInt(parts[1]) - 1, Number.parseInt(parts[2]), 12, 0, 0);
    }
    else if (format == "hyphens-year-month-day-time") {
        let dateTime: string[] = dateString.split(" ");
        let parts: string[] = dateTime[0].split("-");
        return new Date(Number.parseInt(parts[0]), Number.parseInt(parts[1]) - 1, Number.parseInt(parts[2]), 12, 0, 0);
    }
    else if (format == "hyphens-year-month-day-timezone") {
        let trimmed = dateString.substr(0, dateString.indexOf("T"));
        return this.GetDateFromString(trimmed, "hyphens-year-month-day");
    }
    else if (format == "slash-month-day-year") {
        let parts: string[] = dateString.split("/");
        return new Date(Number.parseInt(parts[2]), Number.parseInt(parts[0]) - 1, Number.parseInt(parts[1]), 12, 0, 0);
    }
    else return null;
}

export function SortDates(d1: Date, d2: Date): number {
    if (d1 == undefined) { d1 = new Date(new Date(8640000000000000)); }
    if (d2 == undefined) { d2 = new Date(new Date(8640000000000000)); }
    return d1.getTime() - d2.getTime();
}

export function GetMonthFromNumber(monthNum: number, useShortName: boolean = false): string {
    // if number is outside month range
    if (monthNum > 12 || monthNum < 1) {
        return "";
    }

    const monthNames = ["", "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const shortMonthNames = ["", "Jan", "Feb", "Mar", "Apr", "May", "June",
        "July", "Aug", "Sept", "Oct", "Nov", "Dec"
    ];

    if (useShortName) {
        return shortMonthNames[monthNum];
    }

    return monthNames[monthNum];
}

export function getDisplayDate(date: Date): string {
    if (date == null) {
        return "";
    }

    let convertDate = new Date(date);

    let year = convertDate.getFullYear();
    // Dates in Year One are considered null/empty
    if (year <= 2000) {
        return "";
    }

    let month = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ][convertDate.getMonth()];

    let day = convertDate.getDate().toString().padStart(2, "0");

    //return `${month} ${day}, ${year}`
    return `${day} ${month} ${year}`
}